// `navigator.onLine` is unreliable (false-negatives on Windows / VPN / virtual
// network adapters even when the internet works), so callers never trust it
// alone and do a REAL reachability probe instead: HEAD a tiny same-origin asset.
const CONNECTIVITY_PROBE_URL = "/favicon.ico"; // exists in public/, same-origin (no CORS)

/**
 * Returns true if the network is reachable. A resolved fetch (ANY http status,
 * even 404) means the round-trip succeeded → online. A rejection or a
 * `timeoutMs` timeout means offline / unusably-slow. Cache-buster + `no-store`
 * guarantee a real network hit (no service worker in this app).
 */
export async function probeConnectivity(timeoutMs: number): Promise<boolean> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    await fetch(`${CONNECTIVITY_PROBE_URL}?_=${Date.now()}`, {
      method: "HEAD",
      cache: "no-store",
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
}
